export const getEnumByValue = <T extends Record<string, string>>(
  enumType: T,
  value: string,
): T[keyof T] => {
  const index = Object.values(enumType).indexOf(value);
  return enumType[Object.keys(enumType)[index] as keyof T];
};
